import { useDispatch, useSelector, useStore } from "react-redux";

import type { AppDispatch, AppStore, RootState } from "../@types";
import { createAppDispatchWithMiddlewareHook, listenerMiddleware } from "../utils";

const useAppStore = useStore.withTypes<AppStore>();
const useAppSelector = useSelector.withTypes<RootState>();
const useAppDispatch = useDispatch.withTypes<AppDispatch>();
const useListenerDispatch = createAppDispatchWithMiddlewareHook(listenerMiddleware);

export { useAppDispatch, useAppSelector, useAppStore, useListenerDispatch };
